import { Component, Input } from '@angular/core';
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: 'app-navigation',
    standalone: true,
    imports: [HeaderComponent],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  @Input() content = '';
}
